// Module
var code = `<div class="flex flex-column w-100 h-inherit"> <cdp-mfe class="flex-auto" wsparams="{{\$ctrl.webSocketParams}}" settings="{{\$ctrl.settingsSource}}" language="{{\$ctrl.language}}" user="{{\$ctrl.user}}" isOnTenantContext="{{\$ctrl.isOnTenantContext}}"> </cdp-mfe> </div> `;
// Exports
module.exports = code;